import { InjectionToken } from '@angular/core';

import { ConfirmBoxContent } from './confirm-box.model';

export const CONFIRM_BOX_PARAMS = new InjectionToken<ConfirmBoxContent>(
  'CONFIRM_BOX_PARAMS'
);
